import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SessionSetting } from 'src/app/core/model/session-setting';
import { AppConfigService } from 'src/app/core/service/app-config.service';
import { SettingService } from 'src/app/core/service/setting.service';

@Component({
  standalone: false,
  selector: 'app-community-service-info-detail',
  templateUrl: './community-service-info-detail.component.html',
  styleUrls: ['./community-service-info-detail.component.scss']
})
export class CommunityServiceInfoDetailComponent implements OnInit
{
  @Input() public service: any;
  @Input() public i: number;
  @Input() public servicesCount: number;
  @Input() public reportImageUrl: any;

  public showServiceCorrectionDialog = false;
  public distanceUnitDefault: string;
  public mileText: string;
  public kmText: string;
  public patientLabel = {};
  public mapUrl: string;
  public showMap = false;

  constructor(
    private translate: TranslateService,
    private settingService: SettingService,
    private appConfigService: AppConfigService,) { }

  public ngOnInit(): void
  {
    this.mapUrl = this.appConfigService.getConfig().google.mapBaseUrl + '?q=';
    this.showMap = this.appConfigService.getConfig().google.mapBaseUrl !== null;

    this.translate.get(['DISTANCE-UNIT-MILE', 'DISTANCE-UNIT-KM']).subscribe({
      next: (res) =>
      {
        this.mileText = res['DISTANCE-UNIT-MILE'];
        this.kmText = res['DISTANCE-UNIT-KM'];
      }
    });

    this.settingService.getCachedSessionSettings().subscribe({
      next: (sessionSetting: SessionSetting) =>
      {
        this.distanceUnitDefault = sessionSetting.providerDistanceDisplay;
        this.patientLabel = { patientLabel: sessionSetting.patientLabel };
      }
    });
  }

  public getNotificationPreference(preference: string): string
  {
    return preference.replace("_", " ");
  }

  public formatDistanceLabel(maxDistance: number): any
  {
    const unit = this.distanceUnitDefault === 'MILES' ? this.mileText : this.kmText;
    return `${unit}` + (maxDistance >= 1 ? 's' : '');
  }
}
